import { createFileRoute } from '@tanstack/react-router';
import { Option } from 'effect';
import { ApiDocsRoute } from '../../../api-docs/api-docs-route.tsx';

// The open API lives in the path, which Scalar keeps when it writes its own anchors into the hash.
export const Route = createFileRoute('/documentacao/$api')({
  component: DocumentacaoApi,
});

function DocumentacaoApi(): JSX.Element {
  return <ApiDocsRoute api={Option.some(Route.useParams().api)} />;
}
